import React from "react";
import {
  NewBox as Box,
  NewTable as Table,
  NewTypography as Typography,
} from "@bca/ui-library";
import styled from "styled-components";

import { devices } from "../../constants";
import { SavedSearchesResponseProps } from "../types";
import NonModalWithState from "../NonModalWithState/NonModalWithState";
import { formatDate } from "../utils/formatDate";
import SavedSearchesSwitch from "../SavedSearchesSwitch/SavedSearchesSwitch";
import { getSavedSearchQueryParams } from "../utils/getSavedSearchQueryParams";

const TableStyled = styled(Table)`
  width: 100%;
  padding-top: 24px;
`;

const EllipsisText = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
`;

const TableColumn = styled(Table.DataCell)`
  @media ${devices.tablet} {
    max-width: 200px;
  }

  @media ${devices.tabletL} {
    max-width: 400px;
  }

  @media ${devices.desktopL} {
    max-width: 500px;
  }
`;

const SavedSearchesDesktopView: React.FC<{
  savedData: SavedSearchesResponseProps;
  isToUseAuthZero: boolean;
}> = ({ savedData, isToUseAuthZero }) => {
  const tableHeader = (
    <Table.Row>
      <Table.HeadCell>
        <Typography variant="body-small" color="neutral_700">
          Name
        </Typography>
      </Table.HeadCell>
      <Table.HeadCell>
        <Typography variant="body-small" color="neutral_700">
          Created
        </Typography>
      </Table.HeadCell>
      <Table.HeadCell>
        <Typography variant="body-small" color="neutral_700">
          Last Modified
        </Typography>
      </Table.HeadCell>
      <Table.HeadCell>
        <Typography variant="body-small" color="neutral_700">
          Stock alerts
        </Typography>
      </Table.HeadCell>
      <Table.HeadCell>
        <Typography variant="body-small" color="neutral_700">
          Alerts stop
        </Typography>
      </Table.HeadCell>
      <Table.HeadCell />
    </Table.Row>
  );

  const handleRowClick = (url: string) => {
    window.location.href = `/search${getSavedSearchQueryParams(url)}`;
  };

  const getTableRows = () => {
    return savedData?.savedSearches?.map((data) => (
      <Table.Row key={data.id} onClick={() => {}}>
        <TableColumn onClick={() => handleRowClick(data.url)}>
          <Box display="flex" flexDirection="column" width="100%">
            <Typography weight="heavy">{data.name}</Typography>
            <EllipsisText variant="body-small">{data.description}</EllipsisText>
          </Box>
        </TableColumn>
        <TableColumn onClick={() => handleRowClick(data.url)}>
          <Typography variant="body-small">
            {formatDate(data.createdOn)}
          </Typography>
        </TableColumn>
        <TableColumn onClick={() => handleRowClick(data.url)}>
          <Typography variant="body-small">
            {formatDate(data.modifiedDate)}
          </Typography>
        </TableColumn>
        <TableColumn>
          <SavedSearchesSwitch
            params={{
              id: data.id,
              searchName: data.name,
              url: data.url,
              notifyMe: data.notifyMe,
              deactivationDate: data.deactivationDate,
              deleteOnDeactivation: Boolean(data.deactivationDate),
            }}
            isToUseAuthZero={isToUseAuthZero}
          />
        </TableColumn>
        <TableColumn onClick={() => handleRowClick(data.url)}>
          <Typography variant="body-small">
            {data.deactivationDate ? formatDate(data.deactivationDate) : ""}
          </Typography>
        </TableColumn>
        <TableColumn>
          <NonModalWithState
            data={data}
            isLastElement={
              savedData?.savedSearches?.indexOf(data) ===
              savedData?.savedSearches?.length - 1
            }
          />
        </TableColumn>
      </Table.Row>
    ));
  };

  return (
    <TableStyled aria-label="Saved searches results">
      <Table.Head>{tableHeader}</Table.Head>
      <Table.Body>{getTableRows()}</Table.Body>
    </TableStyled>
  );
};

export default SavedSearchesDesktopView;
